import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IN_ROOM_DINING_CATEGORY_DAYS,
  IN_ROOM_DINING_MENU_TAB,
  IN_ROOM_DINING_MENU_TYPE,
} from '../../../../../constants/InRoomDiningConst';
import CustomFormView from '../../../../../shared/custom-form-view/Custom-Form-View';
import CustomHours from '../../../../../shared/custom-hours/Custom-Hours';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import { formDataValidate } from '../../../../../utils/formUtils';
import { allHotelsSelector } from '../../../../property/propertySlice';
import { getMenuFormData, inRoomDiningMenuFormData, setIsPublished } from '../../../servicesSlice';

const MenuCreateDrawer = (props) => {
  const { toggleDrawer, menu, hotelId, restaurantId } = props;
  const menuForm = useSelector(inRoomDiningMenuFormData);
  const originalHotels = useSelector(allHotelsSelector);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [days, setDays] = useState();
  const [customTime, setCustomTime] = useState([]);
  const [customTimeError, setCustomTimeError] = useState(false);
  const [isTabInValid, setIsTabInValid] = useState(true);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Menu Name',
      errors: {},
      validations: ['required', 'maxLength'],
      maxLength: 100,
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Menu Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    isActive: {
      value: false,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    availableOn: {
      value: 'everyDay',
      fieldName: 'availableOn',
      errors: {},
      validations: [],
      tab: 1,
    },
    days: {
      value: [],
      fieldName: 'days',
      errors: {},
      validations: [],
      tab: 1,
    },
    hours: {
      value: 'allTime',
      fieldName: 'Hours',
      errors: {},
      validations: [],
      tab: 1,
    },
    from: {
      value: '11:00',
      fieldName: 'Hours From',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 1,
    },
    to: {
      value: '23:00',
      fieldName: 'Hours To',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 1,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 2,
    },
  });

  const addFormData = (dataSource) => {
    if (dataSource) {
      setIsTabInValid(false);
      const currFields = { ...formData };
      currFields.name.value = dataSource.name;
      currFields.description.value = dataSource.description || '';
      currFields.code.value = dataSource.code || '';
      currFields.isActive.value = false;
      if (dataSource?.hours && dataSource?.hours.length > 0) {
        const daysToMap = formatArrayForDisplay(dataSource.hours);
        setCustomTime(daysToMap);
        const isEveryDay = dataSource.hours.find((r) => r.day === 'EVERYDAY');
        currFields.availableOn.value = isEveryDay ? 'everyDay' : 'custom';
        currFields.hours.value =
          (isEveryDay?.open && isEveryDay?.close) === 'all day' ? 'allTime' : 'custom';
      }
      currFields.from.value = '11:00';
      currFields.to.value = '23:00';
      currFields.images.value = dataSource.images || [];
      setFormData(currFields);
    }
  };

  const formatArrayForDisplay = (selectedDay) => {
    const daysToReturn = [];
    let daysList = [...selectedDay];
    while (daysList.length > 0) {
      const firstObject = daysList[0];
      const filteredRows = daysList.filter(
        (dayKey) => dayKey.open === firstObject.open && dayKey.close === firstObject.close,
      );
      daysToReturn.push({
        days: filteredRows.map(
          (filteredRowDaysName) =>
            `${filteredRowDaysName.day.charAt(0).toUpperCase()}${filteredRowDaysName.day
              .slice(1)
              .toLowerCase()}`,
        ),
        from: filteredRows[0].open,
        to: filteredRows[0].close,
      });
      const tempDaysList = [...daysList];
      filteredRows.forEach((filteredRowsItem) => {
        const findFilteredDayIndex = tempDaysList.findIndex(
          (tempDaysListItem) => tempDaysListItem.day === filteredRowsItem.day,
        );
        tempDaysList.splice(findFilteredDayIndex, 1);
      });
      daysList = [...tempDaysList];
    }
    return daysToReturn;
  };

  useEffect(() => {
    if (Object.keys(menuForm).length > 0) {
      addFormData(menuForm);
    } else if (menu?.id) {
      addFormData(menu);
    }
  }, [menu, menuForm]);

  const validate = (tabValue) => {
    const updatedFields = {};
    // If tabValue is given, filter out the form fields in current tab
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const resetDaysData = () => {
    const currDays = IN_ROOM_DINING_CATEGORY_DAYS.map((daysValue, ndx) => {
      return {
        id: ndx + 1,
        name: daysValue.name,
        ischecked: false,
        from: null,
        to: null,
      };
    });
    setDays(currDays);
  };

  useEffect(() => {
    resetDaysData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (customTime.length === 0) {
      setCustomTimeError(true);
      setTabValue(1);
      return false;
    }
    setLoading(true);
    let selectedDay = [];
    customTime.forEach((currCustomTime) => {
      currCustomTime.days.forEach((currDay) => {
        selectedDay.push({
          day: currDay.toUpperCase(),
          open: currCustomTime.from,
          close: currCustomTime.to,
        });
      });
    });
    const images = await getProcessedImages(
      rawImages,
      originalHotels.find((hotel) => hotel.id === hotelId).groupId,
      IN_ROOM_DINING_MENU_TYPE,
      hotelId,
    );
    const payload = {
      code: formData.code.value,
      name: formData.name.value,
      description: formData.description.value,
      isActive: formData.isActive.value,
      hours: selectedDay,
      restaurantId,
      categories: [],
      images,
      hotelId,
    };
    dispatch(getMenuFormData(payload));
    dispatch(setIsPublished(false));
    toggleDrawer('', false, '');
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
      return true;
    } else {
      if (tabValue === 1) {
        if (customTime.length === 0) {
          setCustomTimeError(true);
          return false;
        }
      }
      if (validate(tabValue)) {
        setTabValue(newValue);
      }
    }
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images];
    images.splice(index, 1);
    setFormData({ images });
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const onClickNext = () => {
    if (tabValue === 1) {
      if (customTime.length === 0) {
        setCustomTimeError(true);
        return false;
      }
    }
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    setIsTabInValid(!isValid);
    if (tabValue === 1 && customTime.length === 0) {
      setIsTabInValid(true);
    }
  }, [formData, customTime, tabValue]);

  return (
    <CustomFormView
      handleSubmit={handleSubmit}
      tabTitle={IN_ROOM_DINING_MENU_TAB}
      onCancel={onCancel}
      tabValue={tabValue}
      isTabInValid={isTabInValid}
      maxtab={2}
      isUpdate={menu ? true : false}
      loading={loading}
      handleTabChange={handleTabChange}
      title={`${menu ? 'Edit' : 'Add'} Menu`}
      onClickNext={onClickNext}
      titleClass='col-md-4'
      tabClass='col-md-4'
      cancelClass='col-md-4 '
    >
      {tabValue === 0 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
                maxLength={8}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.description}
                handleInputChange={(e) => {
                  setFormData({ description: e });
                }}
                multiline={true}
              />
            </div>
          </div>
        </div>
      )}
      {tabValue === 1 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <CustomHours
            setFormData={setFormData}
            formData={formData}
            days={days}
            customTime={customTime}
            setCustomTime={setCustomTime}
            validate={validate}
            tabValue={tabValue}
            customTimeError={customTimeError}
            setCustomTimeError={setCustomTimeError}
          />
        </div>
      )}
      {tabValue === 2 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <ImageUpload
            uploadedImages={formData.images.value}
            imgList={rawImages}
            onImageListUpdated={onImageListUpdated}
            onUploadedImageRemoval={onUploadedImageRemoval}
            onImagesLoading={(status) => {
              setLoading(status);
            }}
            enabledMediaTabs={['image']}
          />
        </div>
      )}
    </CustomFormView>
  );
};

export default MenuCreateDrawer;
